import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';

const PlatformSelector = ({ platforms, formData, connectedPlatforms, calendarRequiresApproval, onToggle }) => {
  return (
    <Card className="border-slate-100">
      <CardHeader className="pb-2">
        <CardTitle className="text-base font-semibold">Platforms</CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="grid grid-cols-3 sm:grid-cols-5 gap-2">
          {platforms.map((platform) => {
            const isSelected = formData.platforms.includes(platform.id);
            const conn = connectedPlatforms[platform.id];
            const isLive = conn && !conn.demo;
            return (
              <button
                key={platform.id}
                type="button"
                onClick={() => onToggle(platform.id)}
                className={`relative flex flex-col items-center gap-1 p-3 rounded-lg border transition-all ${
                  isSelected
                    ? 'border-emerald-500 bg-emerald-50'
                    : 'border-slate-200 hover:border-slate-300'
                }`}
                data-testid={`platform-${platform.id}`}
              >
                {conn && (
                  <span className={`absolute top-1 right-1 w-2 h-2 rounded-full ${isLive ? 'bg-emerald-500' : 'bg-amber-400'}`} title={isLive ? 'Connected (live)' : 'Demo mode'} />
                )}
                {platform.icon ? (
                  <platform.icon
                    className="h-5 w-5"
                    style={{ color: isSelected ? platform.color : '#94a3b8' }}
                  />
                ) : (
                  <span className="text-xl">{platform.emoji}</span>
                )}
                <span className={`text-xs ${isSelected ? 'text-emerald-700' : 'text-slate-500'}`}>
                  {platform.name}
                </span>
              </button>
            );
          })}
        </div>
        {formData.platforms.length > 0 && Object.keys(connectedPlatforms).length > 0 && (
          <p className="text-xs text-slate-400 mt-2">
            <span className="inline-block w-2 h-2 rounded-full bg-emerald-500 mr-1" />Live
            <span className="inline-block w-2 h-2 rounded-full bg-amber-400 ml-3 mr-1" />Demo
          </p>
        )}
        {calendarRequiresApproval && (
          <div className="mt-3 p-2.5 bg-amber-50 border border-amber-200 rounded-lg text-xs text-amber-700" data-testid="approval-required-notice">
            <strong>Approval required</strong> — This calendar requires client approval before posts can be published or scheduled.
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default PlatformSelector;
